module.exports = __webpack_public_path__ + "static/media/animated_fraz.eaf02c2d.png";